import {
	getBackendErrorMessage,
	isStandardBackendError,
} from '@dealstack/frontend/shared/dataExchange/ApiLayer/apiLayer';

interface ResolveSendErrorMessageArgs {
	error: unknown;
	tDefault: (key: string) => string;
	tMipManage: (key: string) => string;
}

/**
 * Toast text for a failed send. i18next echoes an unknown key straight back, so a code with no
 * Tolgee entry yet must not be shown as-is — fall through to the server's own sentence and
 * then to a generic failure instead of rendering "error_codes.11030103".
 */
export const resolveSendErrorMessage = ({
	error,
	tDefault,
	tMipManage,
}: ResolveSendErrorMessageArgs): string => {
	if (isStandardBackendError(error)) {
		const key = `error_codes.${error.error?.code}`;
		const phrase = tDefault(key);
		if (phrase && !phrase.endsWith(key)) {
			return phrase;
		}
	}

	const backendMessage = getBackendErrorMessage(error);
	if (typeof backendMessage === 'string' && backendMessage.length > 0) {
		return backendMessage;
	}

	return tMipManage('send_documents.toast.send_failed');
};
